import { render, staticRenderFns } from "./ModalNoticeEdit.vue?vue&type=template&id=76866c28&"
import script from "./ModalNoticeEdit.vue?vue&type=script&lang=ts&"
export * from "./ModalNoticeEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports